import script from "./ProductAgriculture.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductAgriculture.vue?vue&type=script&setup=true&lang=js"

import "./ProductAgriculture.vue?vue&type=style&index=0&id=33e930b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e930b1"]])

export default __exports__